<template>
  <material-card
    icon="mdi-clipboard-text"
    icon-small
    color="accent"
    class="mb-16"
  >
    <v-row class="px-10 py-2">
      <v-col cols="6">
        <h2>
          {{ $attrs.semester.shortName }}, {{ $attrs.semester.startDate }}-{{
            $attrs.semester.endDate
          }}
        </h2>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          v-if="school&&school.currentSemesterRef&&
            school.currentSemesterRef.id == $attrs.semester.ref.id
          "
          @click="_setAsCurrentSemester($attrs.semester, false)"
          color="secondary"
          dark
          small
        >
        Идэвxтэй семестр
        </v-btn>
        <v-btn
          v-else
          @click="_setAsCurrentSemester($attrs.semester, true)"
          small
          color="grey"
        >
        Идэвxгүй семестр
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="px-10">
      <!-- <v-col cols="auto">
        <h1>
          {{ $attrs.semester.startYear }}/{{ $attrs.semester.startMonth }} -
          {{ $attrs.semester.endYear }}/{{ $attrs.semester.endMonth }}
        </h1>
      </v-col> -->

      <v-col cols="12" sm="6" md="4">
        <v-menu
          ref="startDateMenu"
          v-model="startDateMenu"
          :close-on-content-click="false"
          :return-value.sync="$attrs.semester.startDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="$attrs.semester.startDate"
              label="Семестрийн эxлэл"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="$attrs.semester.startDate"
            no-title
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Цуцлаx </v-btn>
            <v-btn text color="primary" @click="_saveStartDate">
              Xадгалаx
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          ref="endDateMenu"
          v-model="endDateMenu"
          :close-on-content-click="false"
          :return-value.sync="$attrs.semester.endDate"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="$attrs.semester.endDate"
              label="Семестрийн төгсгөл"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="$attrs.semester.endDate" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menu = false"> Цуцлаx </v-btn>
            <v-btn
              text
              color="primary"
              @click="_saveEndDate($attrs.semester.endDate)"
            >
              Xадгалаx
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <div class="d-flex align-center">
          <p
            class="mb-0 text-body text-xs mr-2"
            v-if="$attrs.semester.rangeable == true"
          >
            Багцаар нь сонгоx
          </p>
          <p class="mb-0 text-body text-xs mr-2" v-else>Нэгээр нь сонгоx</p>
          <v-switch
            v-model="$attrs.semester.rangeable"
            class="ma-0 pa-0"
            color="secondary"
            :ripple="false"
            inset
            hide-details
          />
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="3"
        v-for="(month, idx) in filterdMonths"
        :key="'month' + idx"
      >
        <v-sheet>
          <SchoolYearCalendarX
            v-bind="$attrs"
            :semester="$attrs.semester"
            :datee="month"
          ></SchoolYearCalendarX>
        </v-sheet>
      </v-col>
    </v-row>
  </material-card>
</template>

<script>
import { mapState } from "vuex";
import SchoolYearCalendarX from "./SchoolYearCalendarX";
const fb = require("../../firebaseConfig.js");

export default {
  data: () => ({
    school:null,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    startDateMenu: false,
    endDateMenu: false,
  }),
  components: {
    SchoolYearCalendarX,
  },

  computed: {
    ...mapState(["userProfile", "currentUser"]),
    filterdMonths() {
      var list = [];
      for (
        var year = this.$attrs.semester.startYear;
        year <= this.$attrs.semester.endYear;
        year++
      ) {
        if (this.$attrs.semester.startYear == this.$attrs.semester.endYear) {
          for (
            var month = this.$attrs.semester.startMonth;
            month <= this.$attrs.semester.endMonth;
            month++
          ) {
            list.push(year + "-" + month);
          }
        } else {
          if (year == this.$attrs.semester.startYear) {
            for (
              var month = this.$attrs.semester.startMonth;
              month <= 12;
              month++
            ) {
              list.push(year + "-" + month);
            }
          } else if (year == this.$attrs.semester.endYear) {
            for (
              var month = 1;
              month <= this.$attrs.semester.endMonth;
              month++
            ) {
              list.push(year + "-" + month);
            }
          } else {
            for (var month = 1; month <= 12; month++) {
              list.push(year + "-" + month);
            }
          }
        }
      }
      return list;
    },
  },
  created() {
    fb.db.doc("/schools/YJHjHWUGDok8teDhDIKX").onSnapshot((doc)=>{
       this.school = doc.data()
       this.school.ref = doc.ref
       this.school.id = doc.id
    })
  },
  methods: {
    _setAsCurrentSemester(semester, current) {
      if (current == false) {
        this.school.ref.update({
          currentSemesterRef: null,
          currentSemesterName: null,
          currentSemesterData: null,  
          currentSemesterYears: null,
          currentSemesterNumber: null,
        }).then(()=>{
          semester.ref.update({
            running: true
          })
        })
      } else {
        console.log("add current");
        this.school.ref.update({
          currentSemesterRef: semester.ref,
          currentSemesterName: semester.shortName,
          currentSemesterData: semester,
          currentSemesterYears:
            this.$attrs.xyearStart + "-" + this.$attrs.xyearEnd,
          currentSemesterNumber: semester.code,
        }).then(()=>{
          semester.ref.update({
            running: true
          })
        })
      }

      //   .then(() => {
      //   fb.db
      //     .collection("/schools/YJHjHWUGDok8teDhDIKX/xschoolyears")
      //     .get()
      //     .then((docs) => {
      //       docs.forEach((doc) => {
      //         let xyear = doc.data();
      //         xyear.id = doc.id;
      //         xyear.ref = doc.ref;
      //         xyear.ref.collection("semesters").onSnapshot((docs) => {
      //           docs.forEach((doc) => {
      //             let sem = doc.data();
      //             sem.ref = doc.ref;
      //             sem.id = doc.id;
      //             if (sem.id == semester.id) {
      //               sem.ref.update({ running: true });
      //             } else {
      //               sem.ref.update({ running: false });
      //             }
      //             console.log(sem.name, sem.id, semester.id);
      //           });
      //         });
      //       });
      //     });
      // });
    },
    _saveStartDate() {
      var ddd = this.$attrs.semester.startDate.split("-");
      this.$attrs.semester.ref
        .update({
          startDate: this.$attrs.semester.startDate,
          startYear: parseInt(ddd[0]),
          startMonth: parseInt(ddd[1]),
          startDay: parseInt(ddd[2]),
        })
        .then(() => {
          this.$refs.startDateMenu.save(this.$attrs.semester.startDate);
          this.$forceUpdate();
        });
    },
    _saveEndDate() {
      var ddd = this.$attrs.semester.endDate.split("-");
      this.$attrs.semester.ref
        .update({
          endDate: this.$attrs.semester.endDate,
          endYear: parseInt(ddd[0]),
          endMonth: parseInt(ddd[1]),
          endDay: parseInt(ddd[2]),
        })
        .then(() => {
          this.$refs.endDateMenu.save(this.$attrs.semester.endDate);
          this.$forceUpdate();
        });
    },
  },
};
</script>
  